export default "__VITE_PUBLIC_ASSET__252e369a__"